<div class="db-hosting-manage-environment">
  <ds-mobile-page-title></ds-mobile-page-title>
  <div *ngIf="!stagingAccessOnly && website?.type === 'live' && !stagingEnabled" class="db-hosting-manage-environment__card enable">
    <db-informative-banner (btnClicked)="enableStagingEnvironment()"
                           [demoUser]="demoUser"
                           [title]="'text_stagingEnvironment' | dbText"
                           [description]="(currentSubscription?.trialClient ? 'text_informativeBannerStagingDesc' : 'text_informativeBannerStagingEnable') | dbText">
    </db-informative-banner>
  </div>
  <div class="db-hosting-manage-environment__card manager-enabled"
       [ngClass]="{'manage-disabled': website?.type === 'live' && !stagingEnabled}">
    <div class="db-hosting-manage-environment__item divider">
      <div class="description">
          <div class="desc-header-wrap">
            {{'text_hostingPushToLive' | dbText}}
          </div>
          <div class="desc-body" [innerHTML]="'text_hostingPushToLiveDescription' | dbText"></div>
      </div>
      <div class="button-wrap" (mousemove)="onMouseMove($event)">
        <a class="ds-btn ds-btn-black" (click)="pushToLive()"
           [ngClass]="{'ds-btn-disabled':  syncingWithLive || stagingAccessOnly
           || (ongoingActivityPushToStaging$ | async)}">
          <span>{{'text_hostingPushStagingToLive' | dbText}}</span>
        </a>
        <div class="push-to-live__tooltip" *ngIf="stagingAccessOnly">
          <p [innerHTML]="'text_pushToLiveDecline' | dbText"></p>
        </div>
      </div>
    </div>

    <div class="db-hosting-manage-environment__item">
      <div class="description">
          <div class="desc-header-wrap">
            {{'text_hostingSyncWithLive' | dbText}}
          </div>
          <div class="desc-body" [innerHTML]="'text_hostingSyncStagingWithLiveDescription' | dbText"></div>
        </div>
      <div class="button-wrap" (mousemove)="onMouseMove($event)">
        <a class="ds-btn ds-btn-black"
           [ngClass]="{'ds-btn-disabled': syncingWithLive || stagingAccessOnly || (ongoingActivityPushToStaging$ | async)}" (click)="syncWithLive()">
          <span *ngIf="!syncingWithLive && !(ongoingActivityPushToStaging$ | async)">{{'text_hostingSyncStagingWithLive' | dbText}}</span>
          <span *ngIf="syncingWithLive || (ongoingActivityPushToStaging$ | async)"><db-loading-circular-spinner></db-loading-circular-spinner></span>
        </a>
        <div class="push-to-live__tooltip" *ngIf="stagingAccessOnly">
          <p [innerHTML]="'text_syncWithLiveDecline' | dbText"></p>
        </div>
      </div>
    </div>

    <div class="db-hosting-manage-environment__card disable-staging" *ngIf="website?.type === 'staging' && !stagingAccessOnly">
      <div class="db-hosting-manage-environment__disable-staging-env">
        <a class="mr3" (click)="disableStagingEnvironment()" [ngClass]="{'db-link_disabled': syncingWithLive || (ongoingActivityPushToStaging$ | async)}">
            {{'text_disable' | dbText}}</a> {{ 'text_stagingEnVChangesWillLost' | dbText}}
      </div>
    </div>

  </div>

</div>

<db-loading-screen [ngClass]="{'hidden': !(loading || (ongoingActivityEnable$ | async) || (ongoingActivityDisable$ | async))}"
                   [pageBlocker]="!stagingEnabled && !!(ongoingActivityEnable$ | async)"></db-loading-screen>
